// Voice Service for Text-to-Speech functionality

class VoiceService {
  constructor() {
    this.synth = window.speechSynthesis;
    this.voices = [];
    this.selectedVoice = null;
    this.isEnabled = this.getVoicePreference();
    
    // Load voices
    if (this.synth) {
      this.loadVoices();
      if (speechSynthesis.onvoiceschanged !== undefined) {
        speechSynthesis.onvoiceschanged = () => this.loadVoices();
      }
    }
  }

  loadVoices() {
    this.voices = this.synth.getVoices();
    // Try to find an Indian English voice
    this.selectedVoice = this.voices.find(voice => 
      voice.lang === 'en-IN' || 
      voice.name.includes('Indian') ||
      voice.name.includes('Hindi')
    ) || this.voices.find(voice => voice.lang.startsWith('en-')) || this.voices[0];
  }

  // Check if voice greeting is enabled in settings
  getVoicePreference() {
    const preference = localStorage.getItem('voice_greeting_enabled');
    return preference === null ? true : preference === 'true'; // Default enabled
  }

  // Set voice greeting preference
  setVoicePreference(enabled) {
    this.isEnabled = enabled;
    localStorage.setItem('voice_greeting_enabled', enabled.toString());
  }

  // Check if greeting was already played today
  hasPlayedToday() {
    const lastPlayed = localStorage.getItem('voice_greeting_last_played');
    if (!lastPlayed) return false;
    
    const lastPlayedDate = new Date(lastPlayed);
    const today = new Date();
    
    return (
      lastPlayedDate.getDate() === today.getDate() &&
      lastPlayedDate.getMonth() === today.getMonth() &&
      lastPlayedDate.getFullYear() === today.getFullYear()
    );
  }

  // Mark that greeting was played today
  markAsPlayedToday() {
    localStorage.setItem('voice_greeting_last_played', new Date().toISOString());
  }

  // Get Hinglish greeting based on user login status
  getGreeting(userName = null) {
    if (userName) {
      return `Hello ${userName}! Welcome to Fokat Main! Get ready to play and win exciting gadgets!`;
    } else {
      return "Welcome to Fokat Main! Get ready to play and win exciting gadgets!";
    }
  }

  // Speak the text using Web Speech API
  speak(text, onEnd = null) {
    if (!this.synth || !this.isEnabled) {
      if (onEnd) onEnd();
      return;
    }

    // Cancel any ongoing speech
    this.synth.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    
    // Configure voice settings
    if (this.selectedVoice) {
      utterance.voice = this.selectedVoice;
    }
    
    utterance.lang = 'en-IN'; // Indian English
    utterance.rate = 0.9; // Slightly slower for clarity
    utterance.pitch = 1.0;
    utterance.volume = 1.0;

    utterance.onend = () => {
      if (onEnd) onEnd();
    };

    utterance.onerror = (event) => {
      console.error('Speech synthesis error:', event);
      if (onEnd) onEnd();
    };

    this.synth.speak(utterance);
  }

  // Play welcome greeting
  playWelcomeGreeting(userName = null, onEnd = null) {
    // Check if voice is enabled
    if (!this.isEnabled) {
      if (onEnd) onEnd();
      return;
    }

    // Check if already played today
    if (this.hasPlayedToday()) {
      console.log('Welcome greeting already played today');
      if (onEnd) onEnd();
      return;
    }

    const greeting = this.getGreeting(userName);
    this.speak(greeting, () => {
      this.markAsPlayedToday();
      if (onEnd) onEnd();
    });
  }

  // Stop any ongoing speech
  stop() {
    if (this.synth) {
      this.synth.cancel();
    }
  }

  // Check if browser supports speech synthesis
  isSupported() {
    return 'speechSynthesis' in window;
  }
}

// Export singleton instance
const voiceService = new VoiceService();
export default voiceService;
